/* @flow weak */
import { getStyle } from 'lib/DOM';

export default function findZIndex(node) {
  const nodes = [];
  while (node && node !== document.body) {
    nodes.push(node);
    node = node.parentNode; // eslint-disable-line no-param-reassign
  }

  let l = nodes.length;
  while (l--) {
    node = nodes[l]; // eslint-disable-line no-param-reassign
    const zIndex = getStyle(node, 'z-index');
    if (zIndex &&
        zIndex !== 'auto' &&
        zIndex !== 'initial' &&
        zIndex !== 'inherit') {
      return parseInt(zIndex, 10);
    }
  }
  return 0;
}



// WEBPACK FOOTER //
// ./src/utils/findZIndex.js